export const WORKING_DOCUMENT_ID = 'working-document'
export const HEADER_0 = 'header_0' // Special value for content before first heading, can be handled in UI as needed
